import { v3, v4 } from 'uuid';

export const createUuid = (seed?: string) =>
  seed ? v3(seed, '6ba70a63-4f32-3af3-a8ad-12095131c69c') : v4();
